import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { RSS } from './RSS'

export const RSSFeedsRegistration = createRegisterableComponent(
    'rss-feeds',
    () => <RSS />,
)
